import React, { useState, useEffect } from "react";
import { Modal, Progress } from "reactstrap";
import {
    Paper,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    Typography,
    Button
} from "@material-ui/core";
import styled from "styled-components";

import { noImg } from "vrcore-dashboard/dist/utilities";

const ModalPaper = styled(Paper)`
    width: fit-content;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -0);
    padding: 20px;
    border: 1px solid black;
`;
const StyledButton = styled(Button)`
    float: right;
    margin: 20px !important;
`;

export default props => {
    const [modalInfo, setModalInfo] = useState(props.modalInfo);
    useEffect(() => {
        setModalInfo(props.modalInfo);
    }, [props.modalInfo]);
    let rank = 0;
    return (
        modalInfo.state && (
            <Modal style={{ width: "fit-content" }} isOpen={modalInfo.state}>
                <ModalPaper>
                    <Typography variant="headline">
                        {modalInfo.category} Qualifications
                    </Typography>
                    <div style={{ height: "60vh", overflow: "scroll" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableHeadCell text="Rank" />
                                    <TableHeadCell text="User Name" />
                                    {modalInfo.chartInfo.map(chart => {
                                        return (
                                            <TableCell
                                                key={chart.qualification}
                                            >
                                                <Typography
                                                    style={{ minWidth: 70 }}
                                                    variant="body2"
                                                >
                                                    <b>{chart.qualification}</b>
                                                </Typography>
                                            </TableCell>
                                        );
                                    })}
                                    <TableHeadCell text="Progression" />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {modalInfo.tableInfo.map(tableRow => {
                                    rank++;
                                    return (
                                        <TableRow>
                                            <TableCell>{rank}</TableCell>
                                            <TableCell>
                                                {tableRow.user_name}
                                            </TableCell>
                                            {tableRow.qualificationInfoPerUser.map(
                                                (qualificationInfo, index) => {
                                                    return (
                                                        <TableCell key={index}>
                                                            <img
                                                                src={
                                                                    qualificationInfo.qualification_img ===
                                                                    ""
                                                                        ? noImg
                                                                        : qualificationInfo.qualification_img
                                                                }
                                                                style={{
                                                                    height: 30
                                                                }}
                                                                alt="Qualification Icon"
                                                            />
                                                            <Typography
                                                                variant="caption"
                                                                style={{
                                                                    marginTop: 5
                                                                }}
                                                            >
                                                                {qualificationInfo.expiry_date ===
                                                                ""
                                                                    ? "N/A"
                                                                    : qualificationInfo.expiry_date}
                                                            </Typography>
                                                        </TableCell>
                                                    );
                                                }
                                            )}
                                            <TableCell>
                                                <Progress
                                                    value={
                                                        (tableRow.totalCompleted /
                                                            tableRow
                                                                .qualificationInfoPerUser
                                                                .length) *
                                                        100
                                                    }
                                                />
                                                <div className="text-center">
                                                    {Math.floor(
                                                        (tableRow.totalCompleted /
                                                            tableRow
                                                                .qualificationInfoPerUser
                                                                .length) *
                                                            100
                                                    )}
                                                    %
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </div>
                    <StyledButton
                        onClick={() =>
                            props.setModalInfo({ ...modalInfo, state: false })
                        }
                        variant="contained"
                    >
                        Close
                    </StyledButton>
                </ModalPaper>
            </Modal>
        )
    );
};

const TableHeadCell = ({ text, style }) => {
    return (
        <TableCell style={style}>
            <Typography style={{}} variant="body2">
                <b>{text}</b>
            </Typography>
        </TableCell>
    );
};
